<template>
    <Head title="Register Apelido" />
    <GuestLayout showExtras="true">
        <article>
            <div class="sm:px-5 xl:px-28">
                <p class="pb-2">
                    Como você gostaria de ser <br />
                    chamado(a)? Esse será o nome que <br />
                    aparecerá na tela de início.
                </p>

                <form @submit.prevent="submit">
                    <ul class="grid gap-5 pt-4">
                        <li>
                            <label class="mb-1 mr-5 flex font-semibold pb-1">
                                Apelido:
                            </label>
                            <Input
                                placeholder="Preecha aqui o seu apelido.."
                                type="text"
                                required
                                v-model="form.apelido"
                            />
                        </li>

                        <li>
                            <Button
                                class="
                                bg-disabled
                                w-full
                                grid
                                justify-items-center
                                items-center
                                text-gray-700
                                font-semibold
                                p-3.5
                                "
                            >
                                Avançar
                            </Button>
                        </li>
                    </ul>
                </form>
            </div>
        </article>
    </GuestLayout>
</template>

<script>
import Input from "@/Components/UI/Form/Input.vue";
import GuestLayout from "@/Layouts/Guest.vue";
import Label from "@/Components/Label.vue";
import ValidationErrors from "@/Components/ValidationErrors.vue";
import { Head, Link } from "@inertiajs/inertia-vue3";
import { formatCpf } from "@/Helpers/masks";

export default {

    components: {
        GuestLayout,
        Input,
        Label,
        ValidationErrors,
        Head,
        Link,
    },

    data() {
        return {
            form: this.$inertia.form({
                cpf: sessionStorage.getItem('cpf'),
                name: sessionStorage.getItem('nome'),
                email: sessionStorage.getItem('email'),
                password: sessionStorage.getItem('senha'),
                dataDeNascimento: sessionStorage.getItem('data'),
                apelido: sessionStorage.getItem('apelido'),
            }),
        };
    },

    methods: {
        submit() {
            this.form.apelido = this.apelido;
            this.$inertia.post('/register-apelido', this.form);
        },
    },
    formatCpf,
}
</script>
